import styled from "@emotion/styled";
import { fontMerriweather, transientOptions } from "@product/scmp-sdk";

import { StyledFigcaption } from "~/components/content/content-cover-image/styles";
import { SponsorHeadline } from "~/components/content/content-headline/styles";
import { EntityFollowButton } from "~/components/entity-follow-button";
import { EntityLink } from "~/components/entity-link";
import { StyledLi } from "~/components/schema-render/content/styles";

export const Container = styled.div``;

export const StyledEntityLink = styled(EntityLink)`
  color: #000000;
`;

export const StyledHeadlineEntityLink = styled(StyledEntityLink)``;

export const LinkHighlightArea = styled.div``;

export const SectionContainer = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;

  margin-block-end: 8px;
`;

export const Section = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

export const SectionFollowButton = styled(EntityFollowButton)`
  inline-size: fit-content;

  button {
    inline-size: auto;
    padding: 0;
  }
`;

export const Headline = styled.div`
  display: flex;
  flex-flow: row nowrap;
  gap: 12px;
  align-items: flex-start;

  margin-block-end: 12px;

  font-weight: 700;
  font-size: 18px;
  font-family: ${fontMerriweather};
  line-height: 25.2px;

  ${SponsorHeadline} {
    font-weight: 700;
    font-style: normal;
    line-height: 22.4px;
  }
`;

export const Summary = styled.div`
  margin-block-end: 12px;

  color: #6f6f6f;
  font-size: 14px;
  line-height: 18.2px;

  &:empty {
    margin: 0;
  }
`;

export const SubHeadline = styled.div`
  color: #6f6f6f;
  font-size: 14px;
  line-height: 18.2px;

  ${StyledLi} {
    margin-block-end: 12px;
  }

  &:empty {
    margin: 0;
  }
`;

export const ActionBar = styled.div`
  time {
    color: #999999;
    font-size: 12px;
  }
`;

type StyledCoverEntityLinkProps = {
  $isSponsorArticle?: boolean;
};
export const StyledCoverEntityLink = styled(EntityLink, {
  ...transientOptions,
})<StyledCoverEntityLinkProps>`
  display: ${props => (props.$isSponsorArticle ? "block" : "none")};

  margin-block-start: 12px;

  ${props => props.theme.breakpoints.up("tablet")} {
    display: block;
  }
`;

export const CoverImage = styled.div`
  inline-size: 120px;
  block-size: 80px;

  ${StyledFigcaption} {
    ${props => props.theme.breakpoints.up("tablet")} {
      line-height: 14px;
    }
  }
`;

export const SponsorTagContainer = styled.div`
  max-inline-size: 240px;
`;
